import { Link } from "react-router-dom"
import Bond from "../assets/Bond.svg"
import CustomerSupport from "../assets/CustomerSupport.svg"
import DashboardCases from "../assets/DashboardCases.svg"
import HiringPeople from "../assets/HiringPeople.svg"

function Cases() {
  return (
    <div className="useCases-section" id="cases">
    <h3>Who Can Use Payourl?</h3>
    <div className="useCases-card-group">
      <div className="useCases-card">
        <img src={Bond} alt="bond" />
        <h5>
          Business Owners
        </h5>
        <p>
        Let your customers pay for your products and services easily through the click of your link. No need to go through the stress of sending out bank details and still wait for payment confirmations. Your customers also automatically get payment receipts so your invoices are covered too!
        </p>
      </div>
      <div className="useCases-card">
        <img src={CustomerSupport} alt="customer" />
        <h5>
          Freelancers
        </h5>
        <p>
        Suppose you are a freelance professional, a designer or artist, an independent musician or performer. You can just share your link and get paid if making invoices and payment requests are tedious and awkward for you.
        </p>
      </div>
      <div className="useCases-card">
        <img src={HiringPeople} alt="hiring" />
        <h5>
          Individual
        </h5>
        <p>
        As an individual, you can share link with friends and family for whatever reason. Sharing a bill, chipping in for a gift, collecting a debt from a friend from a night out and so much more.
        </p>
      </div>
    </div>
    <Link className="header-signup-btn hero-btn" to='/signup'>Get Started</Link>
</div>
  )
}

export default Cases